import styled from 'styled-components'
import { colors } from 'client/styles'
import { InputWrapper } from 'client/components/InputLine/styles'

const HISTOGRAM_BAR_MAX_HEIGHT = 40

const loadingBlock = () => `
  opacity: 0.5;
  pointer: events;
`

export const RangeWrapper = styled.div`
  margin-block: 27px 30px;
  margin-inline: 10px;
  ${props => props.isLoading && loadingBlock()}
  .rc-slider-rail {
    height: 2px;
    background-color: ${colors.grey4};
  }
  .rc-slider-track {
    background-color: ${colors.magenta};
    height: 2px;
  }
  .rc-slider-handle {
    width: 24px;
    height: 24px;
    border: solid 2px ${colors.magenta};
    margin-block-start: -11px;
  }
  .rc-slider-handle-dragging.rc-slider-handle-dragging.rc-slider-handle-dragging {
    border-color: ${colors.magenta};
    box-shadow: 0 0 0 5px ${colors.magenta2};
  }
`

export const InputSection = styled.div`
  display: flex;
  justify-content: space-between;
  margin-block-end: 10px;
  ${props => props.isLoading && loadingBlock()}
  ${InputWrapper} {
    max-width: calc(50% - 12px);
  }
`

export const Histogram = styled.div`
  display: flex;
  align-items: flex-end;
  margin-block-end: -5px;
`

export const HistogramPlaceholder = styled.div`
  height: ${HISTOGRAM_BAR_MAX_HEIGHT}px;
  margin-block-end: -5px;
`

export const HistogramBar = styled.div`
  background-color: ${colors.grey4};
  width: 100%;
  height: ${props => (props.percentage * HISTOGRAM_BAR_MAX_HEIGHT) / 100}px;
  border-start-start-radius: 1px;
  border-start-end-radius: 1px;
  border-end-start-radius: 0;
  border-end-end-radius: 0;
  margin-inline: 1px;
  margin-block: 0;
`
